import {
    ENRICHMENT_ANSWER_TYPE_EMAIL,
    ENRICHMENT_ANSWER_TYPE_NUMBER,
    ENRICHMENT_ANSWER_TYPE_OPTIONS,
    ENRICHMENT_ANSWER_TYPE_PHONE,
    ENRICHMENT_ANSWER_TYPE_RATING,
    ENRICHMENT_ANSWER_TYPE_TEXT,
    ENRICHMENT_ANSWER_TYPE_URL,
} from 'common-data-handling';
import _, { first } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import resolvePath from '../../../misc/resolvePath';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import MultipleChoice from '../../elements/forms/MultipleChoice';
import RatingInput from '../../elements/forms/RatingInput';
import EventContentHeader from '../../elements/headers/EventContentHeader';
import Link from '../../elements/Link';
import SafeImage from '../../elements/SafeImage';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import WaitWhileBusy from '../../WaitWhileBusy';
import Screen from './../Screen';
import enrichmentsConnect from './common/connectEnrichments';
import HasEnrichmentCategory from './common/HasEnrichmentCategory';
import HasEnrichmentQuestion from './common/HasEnrichmentQuestion';
import SingleValueEnrichmentAnswer from './common/SingleValueEnrichmentAnswer';
import { EnrichmentsResults } from './EnrichmentsResults';
import EnrichmentProgramItem from './EnrichmentProgramItem';

export class EnrichmentsQuestionScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            busy: false,
            answer: props.question.answer,
            showResultPage: false,
        };

        let { question } = props;
        // If question was already answered and isn't editable, go back
        if (!question.question.editable && question.answer.length) {
            console.warn('Cannot edit the answer to this question');
            app.history.replace(this.props.returnURL);
        }
    }
    componentDidMount() {
        this.state.mounted = true;
        this.focusInput();
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    componentDidUpdate() {
        this.focusInput();
    }
    render() {
        if (this.state.showResultPage) {
            return <EnrichmentsResults {...this.props} currentQuestion={this.props.question} />;
        }

        var { i18n, question, event } = this.props;

        var input, footer;

        switch (question.question.answer_type) {
            case ENRICHMENT_ANSWER_TYPE_EMAIL:
                input = <SingleValueEnrichmentAnswer type="email" value={this.state.answer} onChange={this.handleAnswerChange.bind(this)} />;
                break;
            case ENRICHMENT_ANSWER_TYPE_URL:
                input = <SingleValueEnrichmentAnswer type="url" value={this.state.answer} onChange={this.handleAnswerChange.bind(this)} />;
                break;
            case ENRICHMENT_ANSWER_TYPE_PHONE:
                input = <SingleValueEnrichmentAnswer type="tel" value={this.state.answer} onChange={this.handleAnswerChange.bind(this)} />;
                break;
            case ENRICHMENT_ANSWER_TYPE_TEXT:
                input = <SingleValueEnrichmentAnswer type="textarea" value={this.state.answer} rows="5" onChange={this.handleAnswerChange.bind(this)} />;
                break;
            case ENRICHMENT_ANSWER_TYPE_NUMBER:
                input = <SingleValueEnrichmentAnswer type="number" value={this.state.answer} rows="5" onChange={this.handleAnswerChange.bind(this)} />;
                break;
            case ENRICHMENT_ANSWER_TYPE_OPTIONS:
                input = (
                    <MultipleChoice
                        value={this.state.answer}
                        options={question.question.options}
                        checkboxColor={this.props.headerColor}
                        maxOptions={question.question.max_options}
                        onChange={this.handleAnswerChange.bind(this)}
                    />
                );
                break;
            case ENRICHMENT_ANSWER_TYPE_RATING:
                input = (
                    <div>
                        <br />
                        <RatingInput
                            value={first(this.state.answer)}
                            maxRating={question.question.max_rating}
                            checkedColor={event.settings.primary_color}
                            onChange={(answer) => this.handleAnswerChange([answer])}
                        />
                    </div>
                );
                break;
            default:
                console.error('Unimplemented or invalid question type', question.question.answer_type, question);
                break;
        }

        var btnSave = (
            <button
                type="submit"
                className="btn"
                style={{
                    color: 'white',
                    background: this.props.headerColor,
                }}
                disabled={this.state.busy}>
                {i18n['label.enrich.save']}
            </button>
        );

        if (!question.question.required) {
            footer = (
                <div className="content">
                    <table className="layout">
                        <tbody>
                            <tr>
                                <td>
                                    <Link className="btn" href={this.props.nextPage} onClick={this.handleSkip.bind(this)} disabled={this.state.busy}>
                                        {i18n['label.skip']}
                                    </Link>
                                </td>
                                <td>{btnSave}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            footer = <div className="content">{btnSave}</div>;
        }

        let header = (
            <TopBarEvent returnURL={this.props.returnURL} event={event}>
                {this.props.headerTitle}
            </TopBarEvent>
        );

        return (
            <form ref={(el) => (this.el = el)} onSubmit={this.handleSubmit.bind(this)}>
                <Screen header={header} footer={footer}>
                    <Scrollable>
                        {question.question.image_url ? <SafeImage src={question.question.image_url} width="100%" /> : null}
                        <EventContentHeader>{question.question.text}</EventContentHeader>
                        <EnrichmentProgramItem event={event} program={question.question.Program_item} />
                        <div className="content">
                            {question.question.description ? <p className="content text main">{question.question.description}</p> : null}
                            {input}
                        </div>
                    </Scrollable>
                </Screen>
            </form>
        );
    }
    handleSkip() {
        if (!this.props.nextPage && this.props.onSkip) {
            this.props.onSkip();
        }
    }
    handleAnswerChange(answer) {
        this.setState({ answer });
    }
    async handleSubmit(e) {
        e.preventDefault();

        var answer = this.state.answer;

        if (!_(answer).compact().value().length) {
            await dialogAlert(this.props.i18n['label.required.question']);
        } else {
            this.setState({ busy: true });
            app.api.events
                .saveEnrichmentAnswer(this.props.eventId, this.props.question.id, answer)
                .catch((error) => {
                    // catch moved to above success handler because we always assume success
                    // worst case: if required, question will be shown again on the next refresh
                    console.error(error);

                    // Update local store (we assume success)
                    app.store.dispatch(
                        app.actions.enrichments.updateAnswer(this.props.eventId, {
                            ...this.props.question,
                            answer,
                        })
                    );
                })
                .then(() => {
                    if (this.state.mounted) {
                        this.setState({ busy: false });
                    }
                })
                .then(() => {
                    if (this.props.onSubmitSuccess) {
                        this.props.onSubmitSuccess();
                    } else {
                        this.handleContinue();
                    }
                });
        }
    }
    handleContinue() {
        if (this.props.showResultPage && !this.state.showResultPage) {
            this.setState({ showResultPage: true });
        } else {
            app.history.push(this.props.nextPage);
        }
    }
    focusInput() {
        _.defer(() => {
            if (this.state.mounted) {
                let el = this.el;
                if (el) {
                    let input = el.querySelector('input') || el.querySelector('textarea');
                    if (input) {
                        input.focus();
                    }
                }
            }
        });
    }
}

const EnrichmentsQuestionScreenConnected = connect(function (state, props) {
    let enrichment = enrichmentsConnect(state, props),
        question = _(enrichment.questions).find((question) => {
            return question.id == props.questionId;
        }),
        nextQuestion =
            question &&
            _(enrichment.questions)
                .filter((q) => {
                    return q.number > question.number;
                })
                .minBy((q) => {
                    return q.number - question.number;
                }),
        returnURL = resolvePath(app.history.location.pathname, '..', '..', enrichment.category.intro_text ? '' : '../..');

    let nextPage;
    if (nextQuestion) {
        nextPage = resolvePath(app.history.location.pathname, '..', nextQuestion.id.toString());
    } else {
        nextPage = resolvePath(app.history.location.pathname, '..', '..', 'conclusion');
    }

    return {
        ...enrichment,
        question,
        returnURL,
        nextPage,
        showResultPage: [1, 3].includes(question?.question.show_results),
    };
})(EnrichmentsQuestionScreen);

export default (props) => (
    <WaitWhileBusy>
        <HasEnrichmentCategory {...props.match.params} to="../..">
            <HasEnrichmentQuestion {...props.match.params} to="../..">
                <EnrichmentsQuestionScreenConnected {...props.match.params} key={props.match.params.questionId} />
            </HasEnrichmentQuestion>
        </HasEnrichmentCategory>
    </WaitWhileBusy>
);
